import { z } from 'zod';
import type { TraceStatusType } from '@terra/shared-schemas-ai';
import { SIGNAL_STATUS_SORT_ORDER } from '@terra/shared-schemas-orchestrator';

export const TRACE_STATUS_SORT_ORDER = [
  'RUNNING',
  'PAUSED',
  'BLOCKED',
  'FAILED',
  'ABORTED',
  'COMPLETED',
] as const satisfies readonly TraceStatusType[];

export const TRACE_IN_PROGRESS_STATUSES = [
  'RUNNING',
  'PAUSED',
] as const satisfies readonly TraceStatusType[];

export const isTraceInProgress = (status: TraceStatusType): boolean =>
  TRACE_IN_PROGRESS_STATUSES.some((inProgress) => inProgress === status);

export const TRACE_RESULT_KEY = {
  CONFIRMED_VULNERABILITY_OPEN: 'CONFIRMED_VULNERABILITY_OPEN',
  CONFIRMED_VULNERABILITY_CLOSED: 'CONFIRMED_VULNERABILITY_CLOSED',
  NONE: 'NONE',
} as const;

export const TRACE_RESULT_SORT_ORDER = [
  TRACE_RESULT_KEY.CONFIRMED_VULNERABILITY_OPEN,
  TRACE_RESULT_KEY.CONFIRMED_VULNERABILITY_CLOSED,
  ...SIGNAL_STATUS_SORT_ORDER,
  TRACE_RESULT_KEY.NONE,
] as const;

export const TraceResultKeySchema = z.enum(TRACE_RESULT_SORT_ORDER);

export type TraceResultKey = z.infer<typeof TraceResultKeySchema>;

export const TraceSortFieldSchema = z.enum([
  'createdAt',
  'status',
  'agent',
  'objective',
  'result',
]);

export type TraceSortField = z.infer<typeof TraceSortFieldSchema>;

export const TraceGroupByFieldSchema = z.enum(['status', 'agent', 'result']);

export type TraceGroupByField = z.infer<typeof TraceGroupByFieldSchema>;

export const TraceGroupCountSchema = z.object({
  key: z.string(),
  count: z.int().nonnegative(),
});

export type TraceGroupCount = z.infer<typeof TraceGroupCountSchema>;
